<template>
  <div id="crew-timesheet-list" class="h-full">
    <div class="flex w-full justify-between items-center mx-2 py-2">
      <div class="flex justify-start items-center">
        <div
          class="mr-6 aisea-text-18-600-dark-gray"
          style="word-break: keep-all"
        >
          打刻記録一覧
        </div>
        <vs-tooltip
          text="基準労働時間"
          position="top"
          delay="2s"
          style="position: relative"
        >
          <!-- <v-select
            name="standardWorkPeriod"
            placeholder="基準労働時間を選択"
            v-model="workStandardWorkPeriod"
            :clearable="false"
            :options="standardWorkPeriodList"
            label="dispStandardWorkPeriod"
            class="standard-work-period-list"
            :disabled="standardWorkPeriodList.length === 0"
            @input="onChangeStandardWorkPeriod"
          >
            <template v-slot:no-options>-</template>
          </v-select> -->

          <!-- 基準労働期間ドロップダウン -->
          <standard-working-period
            ref="standardWorkPeriodList"
            :standardWorkPeriodList="standardWorkPeriodList"
            :selectedStandardWorkPeriod="workStandardWorkPeriod"
            :changeSelectedStandardWorkPeriod="onChangeStandardWorkPeriod"
          />
        </vs-tooltip>
      </div>
      <div class="flex justify-end items-center">
        <!-- 右上アクションボタン領域 -->
        <div
          class="list-type-button ml-2"
          :class="[
            listType === 'ALL'
              ? 'list-type-button--selected'
              : 'list-type-button--default',
          ]"
          style="cursor: pointer; word-break: keep-all"
          @click="listType = 'ALL'"
        >
          全て
        </div>
        <div
          class="list-type-button ml-2"
          :class="[
            listType === 'UN_APPLIED'
              ? 'list-type-button--selected'
              : 'list-type-button--default',
          ]"
          style="cursor: pointer; word-break: keep-all"
          @click="listType = 'UN_APPLIED'"
        >
          未申請
        </div>
        <div
          class="list-type-button ml-2"
          :class="[
            listType === 'APPLYING'
              ? 'list-type-button--selected'
              : 'list-type-button--default',
          ]"
          style="cursor: pointer; word-break: keep-all"
          @click="listType = 'APPLYING'"
        >
          申請中
        </div>
        <div
          class="list-type-button ml-2"
          :class="[
            listType === 'APPROVED'
              ? 'list-type-button--selected'
              : 'list-type-button--default',
          ]"
          style="cursor: pointer; word-break: keep-all"
          @click="listType = 'APPROVED'"
        >
          承認済
        </div>
        <div
          class="list-type-button ml-2"
          :class="[
            listType === 'REMAND'
              ? 'list-type-button--selected'
              : 'list-type-button--default',
          ]"
          style="cursor: pointer; word-break: keep-all"
          @click="listType = 'REMAND'"
        >
          差戻し
        </div>
        <div
          class="list-type-button ml-2"
          :class="[
            listType === 'SCHEDULED'
              ? 'list-type-button--selected'
              : 'list-type-button--default',
          ]"
          style="cursor: pointer; word-break: keep-all"
          @click="listType = 'SCHEDULED'"
        >
          作業予定
        </div>
        <div class="flex justify-end items-center mr-2" style="height: 3.2rem">
          <v-select
            placeholder="作業内容で絞り込み"
            label="dispLabel"
            name="crewTask"
            :options="dispCrewTasks"
            v-model="selectedCrewTask"
            class="search-crew-task ml-4"
            data-vv-as="作業内容"
            :clearable="true"
            @input="onCrewTask"
          />
        </div>
      </div>
    </div>

    <div v-if="workStandardWorkPeriod" class="h-full">
      <!-- AgGrid Table -->
      <div style="height: calc(100% - 28px)" @mouseleave="onMouseLeave">
        <ag-grid-vue
          ref="agGridTableCrewTimesheetList"
          :components="components"
          :gridOptions="gridOptions"
          class="ag-theme-material w-full ag-grid-table"
          :columnDefs="columnDefs"
          :defaultColDef="defaultColDef"
          :rowData="dispCrewTimesheets"
          domLayout="autoHeight"
          rowSelection="multiple"
          colResizeDefault="shift"
          :animateRows="true"
          :floatingFilter="false"
          :pagination="true"
          :paginationPageSize="paginationPageSize"
          :suppressPaginationPanel="true"
          :suppressDragLeaveHidesColumns="true"
          :suppressCellFocus="true"
          :suppressRowClickSelection="true"
          :suppressNoRowsOverlay="false"
          @grid-ready="onGridReady"
          @grid-size-changed="onGridSizeChanged"
          @rowClicked="rowClicked"
          @cellMouseOver="onCellMouseOver"
          @bodyScroll="onBodyScroll"
        />

        <!-- 行hover時の編集ボタン領域 -->
        <div
          id="crew-timesheet-list-hover-menu"
          style="display: none; position: absolute"
        >
          <div
            class="flex justify-center items-center"
            :style="{ 'background-color': '#fafafa' }"
            style="height: 45px; border-radius: 4px; padding: 0 0.4rem"
          >
            <vs-tooltip text="差し戻し" position="bottom">
              <div
                class="
                  flex
                  justify-center
                  items-center
                  crew-timesheet-list-hover-icon
                "
                @click.stop="showCrewSidebarForEdit()"
              >
                <vs-icon icon="reply" size="25px" />
              </div>
            </vs-tooltip>
          </div>
        </div>
      </div>

      <!-- ページネーション領域 -->
      <div class="flex justify-end items-center" style="margin: 0.6rem 0">
        <div style="margin-right: 2rem">
          <vs-dropdown vs-trigger-click class="cursor-pointer">
            <div
              class="
                p-4
                border border-solid
                d-theme-border-grey-light
                rounded-full
                d-theme-dark-bg
                cursor-pointer
                flex
                items-center
                justify-between
                font-medium
              "
            >
              <span class="mr-2 aisea-text-12-400-black"
                >{{
                  currentPage * paginationPageSize - (paginationPageSize - 1)
                }}
                -
                {{
                  totalCrewTimesheets - currentPage * paginationPageSize > 0
                    ? currentPage * paginationPageSize
                    : totalCrewTimesheets
                }}
                / {{ totalCrewTimesheets }}</span
              >
              <vs-icon icon="expand_more" />
            </div>
            <vs-dropdown-menu>
              <vs-dropdown-item @click="onChangePageSize(25)">
                <span class="aisea-text-12-400-black">25</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="onChangePageSize(50)">
                <span class="aisea-text-12-400-black">50</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="onChangePageSize(75)">
                <span class="aisea-text-12-400-black">75</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="onChangePageSize(100)">
                <span class="aisea-text-12-400-black">100</span>
              </vs-dropdown-item>
            </vs-dropdown-menu>
          </vs-dropdown>
        </div>

        <div>
          <vs-pagination
            v-if="isReadyPagination"
            :total="totalPages"
            :max="7"
            v-model="currentPage"
            :color="AISEA_COLOR.BLUE"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { AgGridVue } from "ag-grid-vue";
import "@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss";
import Vue from "vue";
import vSelect from "vue-select";
import moment from "moment-timezone";
import FireStoreService from "@/services/fireStoreService";
import { AiseaApiFactory } from "@/api/aisea/apiFactory";
import CellRendererLink from "./cell-renderer/CellRendererLink.vue";
import CellRendererTimesheetStatus from "./cell-renderer/CellRendererTimesheetStatus.vue";
const enterpriseCrewTimesheetApi = AiseaApiFactory.get(
  "enterpriseCrewTimesheet"
);

import { createNamespacedHelpers } from "vuex";
const { mapActions, mapState } = createNamespacedHelpers("crewTimesheet");
const { mapState: mapStateOfCrewAccount } = createNamespacedHelpers(
  "crewAccount"
);
const {
  mapState: mapStateOfCrewLabors,
  mapMutations,
} = createNamespacedHelpers("crewLabor");
import { DeviceInfoMixin, ColorMixin } from "@/mixins";

import StandardWorkingPeriod from "../standard-working-period/StandardWorkingPeriod";

export default {
  components: {
    AgGridVue,
    vSelect,
    // eslint-disable-next-line vue/no-unused-components
    CellRendererLink,
    // eslint-disable-next-line vue/no-unused-components
    CellRendererTimesheetStatus,
    StandardWorkingPeriod,
  },
  props: {
    enterpriseCrewId: String,
    activeSidebarCrew: Boolean,
    activeTab: Number,
  },
  mixins: [DeviceInfoMixin, ColorMixin],
  data() {
    return {
      listType: "ALL",
      crewLabors: [],
      crewTimesheets: [],
      crewTimesheetParam: {},
      searchResult: {},
      hoveredIdByRow: null,
      hoveredStatusByRow: null,
      updatedIdList: [],
      showDeletePrompt: false,
      deleteDispId: "",
      standardWorkPeriod: {},
      workStandardWorkPeriod: null,

      actionButtonTimer: null,
      agGridScrollPosition: -1,

      pageable: {
        page: 0,
        total_elements: 0,
        total_pages: 1,
      },

      selectedCrewTask: null,

      searchCondition: {
        daytime_in: null,
        daytime_out: null,
        crew_task_id: null,
        status: "ALL", // ALL, UN_APPLIED, APPLYING, APPROVED, REMAND, SCHEDULED
        page: 0,
        size: 50,
      },

      currentPage: 1,
      gridApi: null,
      gridOptions: {
        localeText: {
          noRowsToShow:
            '<div id="no-rows-crew-timesheet-list" class="aisea-text-16-400-black">表示する打刻記録がありません。</div>',
        },
        context: {
          componentParent: this,
        },
      },
      pageSize: 50,
      defaultColDef: {
        sortable: false,
        resizable: true,
        suppressMenu: true,
      },
      columnDefs: [],
      components: {
        CellRendererLink,
        CellRendererTimesheetStatus,
      },
      isReadyPagination: false,
      prevRoute: null,
    };
  },
  watch: {
    currentPage() {
      this.searchCondition.page = this.getCurrentPage();
      FireStoreService.setAccountSetting("crew_timesheet_list", {
        current_page: this.currentPage,
      });
      this.clearCrewTimesheetListHoverMenu();
      this.searchCrewTimesheets();
    },
    enterpriseCrewId() {
      this.currentPage = 1;
      this.initStandardWorkPeriodList();
    },
    activeSidebarCrew(val) {
      if (!val) {
        document.getElementById("crew-timesheet-list").click();
      }
    },
    async activeTab(val) {
      if (val === 2) {
        this.SET_ENTERPRISE_CREW_ID(this.$route.params.id);
        this.initStandardWorkPeriodList();
        this.autoSizeAll();
        await this.$refs.standardWorkPeriodList.initWorkingPeriodList();
      }
    },
    listType(val) {
      this.searchCondition.status = val;
      this.currentPage = 1;
      this.reloadList();
    },
  },
  computed: {
    ...mapState({
      crewTasks: state => state.crewTasks,
      crewTimesheetStatusMap: state => state.crewTimesheetStatusMap,
    }),
    ...mapStateOfCrewAccount({
      crewAccount: state => state.crewAccount,
    }),
    ...mapStateOfCrewLabors(["labors"]),
    sidebarStatus: {
      get() {
        return this.activeSidebarCrew;
      },
      set(val) {
        this.$emit("update:activeSidebarCrew", val);
      },
    },
    standardWorkPeriodList: {
      get() {
        return this.labors;
      },
      set(val) {
        this.SET_LABORS(val);
      },
    },
    dispCrewTimesheets() {
      return JSON.parse(JSON.stringify(this.crewTimesheets)).map(
        crewTimesheet => {
          crewTimesheet.dispStatus = this.crewTimesheetStatusMap[
            crewTimesheet.display_status
          ];
          const task = crewTimesheet.crew_task;
          crewTimesheet.dispLabel = task.is_custom
            ? task.label
            : this.$t(`Views.Crew.LaborRecord.Tasks.${task.label}`);

          if (this.updatedIdList.includes(crewTimesheet.id)) {
            crewTimesheet.isUpdated = true;
          }
          return crewTimesheet;
        }
      );
    },
    paginationPageSize() {
      return this.pageSize;
    },

    totalPages() {
      if (this.pageable) return this.pageable.total_pages;
      else return 0;
    },

    totalCrewTimesheets() {
      if (this.pageable) return this.pageable.total_elements;
      else return 0;
    },

    dispCrewTasks() {
      console.log(this.crewTasks);
      const dispCrewTasks = this.crewTasks.map(task => {
        task.dispLabel = task.is_custom
          ? task.label
          : this.$t(`Views.Crew.LaborRecord.Tasks.${task.label}`);
        return task;
      });
      dispCrewTasks.sort((a, b) => {
        // sort_orderでソート
        let comparison = 0;
        if (a.sort_order > b.sort_order) {
          comparison = 1;
        } else if (a.sort_order < b.sort_order) {
          comparison = -1;
        }
        return comparison;
      });
      return dispCrewTasks;
    },
  },
  methods: {
    ...mapActions(["fetchAllCrewTasks"]),
    ...mapMutations(["SET_ENTERPRISE_CREW_ID", "SET_LABORS"]),

    async initStandardWorkPeriodList() {
      this.SET_ENTERPRISE_CREW_ID(this.$route.params.id);
      await this.$refs.standardWorkPeriodList.initWorkingPeriodList();

      this.crewTimesheets = [];
      this.selectedCrewTask = null;
      this.searchCondition.crew_task_id = null;

      this.standardWorkPeriodList = this.standardWorkPeriodList.map(period => {
        period.dispStandardWorkPeriod =
          moment(period.work_period_from)
            .local()
            .format("YYYY/MM/DD") +
          " 〜 " +
          moment(period.work_period_to)
            .local()
            .format("YYYY/MM/DD");
        return period;
      });

      this.setSearchCondition(this.workStandardWorkPeriod);
      this.reloadList();
    },

    setSearchCondition(val) {
      const newStandardWorkPeriod = val
        ? val
        : JSON.parse(JSON.stringify(this.workStandardWorkPeriod));
      this.standardWorkPeriod = newStandardWorkPeriod;
      this.searchCondition.daytime_in = moment(
        newStandardWorkPeriod.work_period_from + "T00:00:00.000"
      )
        .utc()
        .toISOString();
      this.searchCondition.daytime_out = moment(
        newStandardWorkPeriod.work_period_to + "T23:59:59.999"
      )
        .utc()
        .toISOString();
    },

    onChangeStandardWorkPeriod(val) {
      this.workStandardWorkPeriod = val;
      this.setSearchCondition(val);
      this.reloadList();
    },

    async onGridReady() {
      this.gridApi = this.gridOptions.api;
      this.gridColumnApi = this.gridOptions.columnApi;
      this.searchCrewTimesheets();
    },

    onCrewTask(val) {
      this.searchCondition.crew_task_id = val ? val.id : null;
      this.currentPage = 1;
      this.reloadList();
    },

    reloadList() {
      this.searchCrewTimesheets();
    },

    async searchCrewTimesheets() {
      if (
        !this.searchCondition.daytime_in ||
        !this.searchCondition.daytime_out
      ) {
        this.crewTimesheets = [];
        Vue.set(this.pageable, "page", 0);
        Vue.set(this.pageable, "total_elements", 0);
        Vue.set(this.pageable, "total_pages", 1);
        return;
      }
      this.$vs.loading({ color: this.AISEA_COLOR.BLUE });
      try {
        const res = await enterpriseCrewTimesheetApi.search(
          this.enterpriseCrewId,
          this.searchCondition
        );
        // TODO: ソートが必要な場合はAPI側に依頼

        this.crewTimesheets = res.data.timesheet_list || [];

        Object.keys(res.data.pageable).forEach(key => {
          Vue.set(this.pageable, key, res.data.pageable[key]);
        });
        this.autoSizeAll();
        this.$vs.loading.close();
      } catch (e) {
        this.$vs.loading.close();
      }
    },

    async restoreSearchCondition(crewTimesheetSetting) {
      // TODO: firestore個人設定のリストアを再調整
      this.currentPage = 1;
      this.setPageSize(
        crewTimesheetSetting && crewTimesheetSetting.page_size
          ? crewTimesheetSetting.page_size
          : 50
      );

      this.searchCondition = {
        ...this.searchCondition,
        page: this.getCurrentPage(),
        size: this.pageSize,
      };

      // currentPage は vs-pagination がロードされる前に初期値をセットしておく。
      this.isReadyPagination = true;
    },

    setPageSize(size) {
      this.pageSize = size;
      this.searchCondition.size = size;
      FireStoreService.setAccountSetting("crew_timesheets_list", {
        page_size: this.pageSize,
      });
    },

    getCurrentPage() {
      return this.currentPage - 1;
    },

    async showCrewSidebarForEdit() {
      this.crewTimesheetParam = this.dispCrewTimesheets.find(
        x => x.id === this.hoveredIdByRow
      );
      const res = await enterpriseCrewTimesheetApi.fetch(
        this.enterpriseCrewId,
        this.crewTimesheetParam.id
      );
      if (res.status) {
        this.crewTimesheetParam = res.data;
      }
      this.crewTimesheetParam[
        "workStandardWorkPeriod"
      ] = this.workStandardWorkPeriod;
      this.sidebarStatus = true;
      this.$emit("setDialogTitle", "差し戻し");
      this.clearCrewTimesheetListHoverMenu();
    },

    onBodyScroll(e) {
      if (e.direction === "vertical") {
        this.agGridScrollPosition = e.top;
        this.clearCrewTimesheetListHoverMenu();
      }

      // TODO: 横スクロール発生時には調整
      if (e.direction === "horizontal") {
        console.debug("### onBodyScroll", e);
        // this.repositionSortIcons();
      }
    },

    updatedId(id) {
      if (!this.updatedIdList.includes(id)) {
        this.updatedIdList.push(id);
      }
    },

    customizeCellStyle(params) {
      if (params.data.isUpdated) {
        return {
          backgroundColor: "lightyellow",
        };
      }
      return null;
    },

    rowClicked(e) {
      this.hoveredIdByRow = e.data.id;
      this.hoveredStatusByRow = e.data.display_status;
      if (this.sidebarStatus) {
        this.sidebarStatus = false;
      }
    },

    onGridSizeChanged() {
      this.autoSizeAll();
    },

    onMouseLeave() {
      this.clearCrewTimesheetListHoverMenu();
    },

    onCellMouseOver(e) {
      this.dispCrewTimesheets.forEach(dispCrewTimesheet => {
        dispCrewTimesheet.hoveredRow = e.data.id === dispCrewTimesheet.id;
      });
      this.hoveredIdByRow = e.data.id;
      this.hoveredStatusByRow = e.data.display_status;

      const baseRect = this.$refs.agGridTableCrewTimesheetList.$el
        .querySelector(".ag-body-viewport")
        .getBoundingClientRect();

      if (
        e.node.rowTop - this.agGridScrollPosition >= 0 &&
        baseRect.height -
          (e.node.rowTop + e.node.rowHeight - this.agGridScrollPosition) >=
          -1 &&
        (this.hoveredStatusByRow === 3 || this.hoveredStatusByRow === 4)
      ) {
        // 差し戻し可能なもの(申請中と承認済)だけボタンを表示
        // 差し戻しボタンを表示
        let el = document.getElementById("crew-timesheet-list-hover-menu");
        const hoverMenuButtonOffset = 169;
        el.style["top"] =
          e.node.rowTop +
          hoverMenuButtonOffset -
          this.agGridScrollPosition +
          "px";
        el.style["display"] = "block";
      } else {
        this.clearCrewTimesheetListHoverMenu();
      }

      this.setActionButtonTimer();
    },

    clearCrewTimesheetListHoverMenu() {
      let el = document.getElementById("crew-timesheet-list-hover-menu");
      if (el) {
        el.style["display"] = "none";
        el.style["top"] = "0";
      }
    },

    setActionButtonTimer() {
      if (this.actionButtonTimer) {
        clearTimeout(this.actionButtonTimer);
      }
      this.actionButtonTimer = setTimeout(() => {
        this.clearCrewTimesheetListHoverMenu();
      }, 3000);
    },

    onChangePageSize(size) {
      this.setPageSize(size);
      this.currentPage = 1;
      this.searchCrewTimesheets();
    },

    autoSizeAll() {
      if (this.gridColumnApi) {
        let allColumnIds = [];
        if (this.gridColumnApi && this.gridColumnApi.getAllColumns()) {
          this.gridColumnApi.getAllColumns().forEach(function(column) {
            allColumnIds.push(column.getId());
          });
          this.gridColumnApi.autoSizeColumns(allColumnIds, false);
        }
        if (
          this.$refs.agGridTableCrewTimesheetList &&
          this.$refs.agGridTableCrewTimesheetList.$el.getBoundingClientRect()
            .width > 0
        ) {
          this.gridApi.sizeColumnsToFit(); // TODO: 横スクロールありの場合は、別途調整
        }
      }
    },
  },
  created() {
    this.fetchAllCrewTasks();
  },
  async beforeMount() {
    this.gridOptions["onFirstDataRendered"] = this.autoSizeAll;

    const initialColumnDefs = [
      {
        headerName: "作業開始日時",
        width: 80,
        field: "daytime_in",
        cellRenderer: "CellRendererLink",
        cellStyle: params => this.customizeCellStyle(params),
      },
      {
        headerName: "作業終了日時",
        width: 80,
        field: "daytime_out",
        cellRenderer: "CellRendererLink",
        cellStyle: params => this.customizeCellStyle(params),
      },
      {
        headerName: "作業内容",
        width: 100,
        field: "dispLabel",
        cellStyle: params => this.customizeCellStyle(params),
      },
      {
        headerName: "ステータス",
        field: "dispStatus",
        width: 80,
        cellRenderer: "CellRendererTimesheetStatus",
        cellStyle: params => this.customizeCellStyle(params),
      },
      {
        headerName: "修正日時",
        width: 80,
        field: "updated_at",
        cellRenderer: "CellRendererLink",
        cellStyle: params => this.customizeCellStyle(params),
      },
      {
        headerName: "修正者",
        width: 120,
        field: "changer",
        cellStyle: params => this.customizeCellStyle(params),
      },
    ];
    let columnDefs = [];
    const crewTimesheetSetting = await FireStoreService.getAccountSetting(
      "crew_timesheet_list"
    );
    if (
      crewTimesheetSetting &&
      crewTimesheetSetting.columns &&
      crewTimesheetSetting.columns.length > 0
    ) {
      crewTimesheetSetting.columns.forEach(columnId => {
        const columnDef = initialColumnDefs.find(
          columnDef => columnDef.field === columnId
        );
        if (columnDef) {
          columnDefs.push(columnDef);
        }
      });
    } else {
      columnDefs = initialColumnDefs;
    }
    this.columnDefs = columnDefs;
    this.pageSize =
      crewTimesheetSetting && crewTimesheetSetting.page_size
        ? crewTimesheetSetting.page_size
        : 50;
    this.$nextTick(async () => {
      await this.restoreSearchCondition(crewTimesheetSetting);
      this.autoSizeAll();
    });
  },
  mounted() {
    let routerViewElement = document.getElementsByClassName("router-view");
    routerViewElement[0].style.padding = "2.2rem";

    let self = this;
    window.onresize = function() {
      self.$nextTick(() => {
        self.autoSizeAll();
      });
    };

    this.initStandardWorkPeriodList();
  },
  beforeDestroy() {},
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.prevRoute = from;
    });
  },
};
</script>

<style lang="scss">
@import "src/assets/scss/aisea/variables";

#crew-timesheet-list {
  .vs-avatar--con-img img {
    object-fit: cover;
  }
  .ag-grid-table {
    height: 100%;

    font-family: $aisea-font-family;
    font-size: 16px;
    font-weight: 400;

    .ag-header-cell-text {
      font-family: $aisea-font-family;
      font-size: 12px;
      font-weight: 600;
    }
  }
  .ag-header-cell {
    padding-right: 0;
  }
  .vs-tabs--content {
    padding: 4px 0 0 0;
  }
  .vs__search {
    margin: 0 !important;
    padding: 0 !important;
  }

  .sort-icons {
    flex-direction: column;
    z-index: 9;
    i {
      cursor: pointer;
      border-radius: 4px;
      &:hover {
        background-color: $aisea-white;
      }
    }
  }

  .standard-work-period-list {
    width: 18rem;
    margin-top: 2px;

    .vs__selected {
      font-family: $aisea-font-family;
      font-size: 16px;
      font-weight: 400;
    }
    .vs__dropdown-menu li {
      font-family: $aisea-font-family;
      font-size: 16px;
      font-weight: 400;
    }
    .vs__dropdown-option--highlight {
      background-color: $aisea-blue;
    }
  }
  .v-select {
    font-family: $aisea-font-family;
    font-size: 16px;
    font-weight: 400;

    input {
      height: 2rem;
    }
  }
  .search-crew-task {
    min-width: 16rem;

    .vs__selected {
      word-break: keep-all;
    }
    input.vs__search {
      margin-top: 2px !important;
    }
    .vs__search::placeholder {
      padding-left: 0.6rem;
      color: $aisea-light-gray;
    }
  }

  .vs-pagination--ul {
    span {
      font-size: 12px;
      font-family: $aisea-font-family;
      font-weight: 400;
    }
  }

  .list-type-button {
    display: flex;
    align-items: center;
    padding: 0 8px;
    height: 32px;
    border-radius: 15px;

    font-family: $aisea-font-family;
    font-size: 14px;

    &--selected {
      border: 1px solid $aisea-blue;
      padding-bottom: 4px;
      background-color: $aisea-blue;
      color: $aisea-pure-white;
      font-weight: 600;
      &:hover {
        background-color: #0277bd;
      }
    }
    &--default {
      border: 1px solid $aisea-light-gray;
      padding-bottom: 0px;
      background-color: none;
      color: none;
      font-weight: 400;
      &:hover {
        color: $aisea-blue;
        border-color: $aisea-blue;
      }
    }
  }
  #crew-timesheet-list-hover-menu {
    height: 0;
    right: 31px;

    .crew-timesheet-list-hover-icon {
      border-radius: 4px;
      padding: 8px;
      &:hover {
        background-color: $aisea-light-white;
      }
    }
  }
}
</style>
